import React, { createContext, useContext, useEffect, useState } from 'react';
import { onAuthStateChanged, signOut } from 'firebase/auth';
import { doc, onSnapshot } from 'firebase/firestore';
import { auth, db } from '../lib/firebase';

const AuthContext = createContext();

export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
  const [currentUser, setCurrentUser] = useState(null);
  const [subscription, setSubscription] = useState(null);
  const [loading, setLoading] = useState(true);
  const [subscriptionLoading, setSubscriptionLoading] = useState(false);

  const logout = () => signOut(auth);

  useEffect(() => {
    const unsubAuth = onAuthStateChanged(auth, (user) => {
      setCurrentUser(user);
      if (!user) {
        setSubscription(null);
        setSubscriptionLoading(false);
      } else {
        setSubscriptionLoading(true);
      }
      setLoading(false);
    });
    return unsubAuth;
  }, []);

  useEffect(() => {
    if (!currentUser) return;
    const unsubFirestore = onSnapshot(doc(db, 'users', currentUser.uid), (snap) => {
      setSubscription(snap.exists() ? (snap.data()?.subscription ?? null) : null);
      setSubscriptionLoading(false);
    });
    return unsubFirestore;
  }, [currentUser]);

  const SUPERUSERS = ['angsak6@gmail.com'];
  const isSuperUser = currentUser && SUPERUSERS.includes(currentUser.email);

  // trialing = card on file, in free trial; active = paying subscriber
  const hasAccess = isSuperUser || subscription?.status === 'active' || subscription?.status === 'trialing';
  const isTrialing = subscription?.status === 'trialing';

  const trialDaysLeft = (() => {
    if (!isTrialing || !subscription?.trialEnd) return null;
    const end = subscription.trialEnd?.toDate?.() ?? new Date(subscription.trialEnd);
    return Math.max(0, Math.ceil((end - new Date()) / (1000 * 60 * 60 * 24)));
  })();

  return (
    <AuthContext.Provider value={{ currentUser, subscription, hasAccess, isSuperUser, isTrialing, trialDaysLeft, loading, subscriptionLoading, logout }}>
      {children}
    </AuthContext.Provider>
  );
};
